<template>
  <div class="uk-flex" style="height: 500px;">
    <!-- 左边监测点列表 -->
    <div class="w-20 pd-10 pr">
      <div class="uk-flex mb-10">
        <el-input class="ml-5" v-model="carrierName"
            :placeholder="$t('integration.name_of_monitoring_point')"></el-input>
        <el-button type="primary" icon="el-icon-search"
          style="margin-right: 0 !important;"
         @click="searchCarrier"></el-button>
      </div>
      <div v-if="carrierList.length" style="height:90%;overflow-y: auto;">
        <div v-for="item in carrierList" :key="item.id"
            class="bg-theme color-white pd-10 mb-10 uk-flex uk-flex-between cursor-pointer " >
            <p @click="changeCarrier(item)" class="uk-flex-1 cursor-pointer ellipsis">{{item.keycode}}</p>
            <i class="el-icon-circle-close color-red" @click="delCarrierFn(item)"></i>
        </div>
      </div>
      <div v-else style="height:90%;">
        <el-empty  :description="$t('public.no_data')"></el-empty>
      </div>
      <el-button type="primary" style="width:100%;color:#fff;"
        @click="addDeviceCarrier" > +
      </el-button>
    </div>
    <!-- 右边新增监测点表单 -->
    <div class="bd-l pd-10 pr" style="width:80%;">
       <el-form ref="form" :model="dioForm" :rules="rules" label-width="160px"
        style="height: 95%;overflow-y: auto;">
          <el-form-item :label="$t('integration.unit_path')" prop="structureText">
            <div class="uk-flex">
              <el-select style="width:250px" v-model="dioForm.structureText" popper-class="Architecture">
                  <el-option :value="dioForm.structureText">
                      <div class="treeClass">
                          <trees @changeNode="nodeClick" :treedata="treeData" ref="tree" />
                      </div>
                  </el-option>
              </el-select>
              <span v-if="!isShowUnitInput" class="under-line ml-10" @click="isShowUnitInput = true">{{$t('integration.add_department')}}</span>
              <div v-else class="uk-flex">
                <span class="ml-10 mr-10" >/</span>
                <el-input style="width:100px;" v-model="dioForm.structureName" maxlength="80"/>
                <i class="iconfont icon-backward ml-10" :title="$t('integration.back')" @click="isShowUnitInput = false"></i>

              </div>
            </div>
          </el-form-item>
          <el-form-item :label="$t('public.carrier')" prop="carrierName">
              <el-input v-model.trim="dioForm.carrierName" maxlength="50" style="width: 250px"></el-input>
          </el-form-item>
          <el-form-item :label="$t('public.mode')" prop="carrierModel">
            <el-select style="width:250px" v-model="dioForm.carrierModel">
                <el-option :label="getLanguage() === 'zh_CN'? item.name:item.content" :value="parseInt(item.code)"
                  :key="parseInt(item.code)" v-for="item in modeList"></el-option>
            </el-select>
          </el-form-item>
          <!-- 监测点类型 -->
          <el-form-item
            :label="$t('public.carrierType')"
            prop="carrierType"
          >
            <el-select
              v-model='dioForm.carrierType'
              style="width: 250px"
              :placeholder="$t('integration.please_select')">
              <el-option v-for='item in carrierTypeOptions' :key='item.value' :label='item.label' :value='item.value'>
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 监测区间 -->
           <el-form-item
            :label="$t('integration.monitoring_interval')"
          >
            <i
              class="el-icon-circle-plus-outline font-24 mt-5 "
              v-if="isPulsBool"
              style="cursor: pointer"
              @click="handleClick"
            ></i>
            <template v-if="!isPulsBool">
              <div class="probeClass" v-for="(option, index) in ranges" :key="index">
                <el-select
                  v-model="option.unitId"
                  style="width: 100px;margin-right:10px"
                  @change="changeFn($event, index)"
                  :popper-append-to-body="false"
                >
                  <el-option
                    v-for="item in renderUnits"
                    :key="item.id"
                    :disabled="item.disabled"
                    :label="item.title"
                    :value="item.id"
                  >
                    <span
                      :title="
                        $t(
                          'integration.a_uom_can_only_correspond_to_one_monitoring_interval'
                        )
                      "
                      >{{ item.title }}
                    </span>
                  </el-option>
                </el-select>
                <el-select
                  v-model="option.id"
                  style="width: 100px;margin-right:10px"
                  @change="changeNameFn($event, index)"
                  :popper-append-to-body="false"
                >
                  <el-option
                    v-for="item in option.forwardNameArray"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                    <span>
                      {{ item.name }}
                    </span>
                  </el-option>
                </el-select>
                <span>
                  <template v-if="option.unitId === 'custom'">
                    <el-input v-model="option.min " style="width:60px;"></el-input>
                  </template>
                  <template v-else>
                    {{ option.min }}
                  </template>
                  {{ option.unit }}
                  </span>
                  <span v-if="option.unit">~</span>
                  <span>
                    <template v-if="option.unitId === 'custom'">
                      <el-input v-model="option.max" style="width:60px;"></el-input>
                    </template>
                    <template v-else>
                      {{ option.max }}
                    </template>
                    {{ option.unit }}
                  </span>
                  <i class="el-icon-plus" style="cursor: pointer" @click="addRow"></i>
                  <i
                    class="el-icon-delete"
                    style="cursor: pointer"
                    @click="delRow(index, option)"
                  ></i>
              </div>
            </template>
           </el-form-item>
           <!-- 设备 -->
           <el-form-item
              prop="device"
              :label="$t('public.device')">
              <!-- <div class="uk-flex">
                <i class="el-icon-circle-plus-outline font-24 mt-5" style="cursor: pointer" @click="showDeviceDiaFn"></i>
              </div> -->
              <div style="width:90%;">
                <div v-for="(value,key, index) in deviceList" :key="index">
                  <div v-if="value && value.length"  class="border">
                    <div class="bd-b" style="text-align: center;">{{ deviceTypeConvert(key)}}</div>
                    <div class="uk-flex color-white" style="flex-wrap: wrap;">
                      <div v-for="(dev, index2) in value" :key="`${index}_${index2}`"
                        style="width:150px;margin:10px;">
                        <p class="font-16  cursor-pointer " style="text-align: center;"
                          :class="{'bg-orange': dev.select,
                            'bg-theme': !dev.carrierDeviceId,
                            'bg-gray': dev.carrierDeviceId && dev.carrierDeviceStatus ===1,
                            'bg-gray-2': dev.carrierDeviceId && dev.carrierDeviceStatus !==1

                          }"
                          :style="{cursor: dev.carrierDeviceId && dev.carrierDeviceStatus ===1 ? 'not-allowed': 'pointer'}"
                         @click="handleSelectDevice(dev)">{{dev.deviceCode}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
           </el-form-item>

           <!-- <el-form-item>
             <div class="uk-flex" style="flex-wrap: wrap;">
              <div v-for="(item,index) in  dioForm.deviceList" :key="index">
                <div v-if="item.changeDeviceCode"
                  class="color-white pd-5 bg-orange pr"
                  style="width:150px;margin:10px;"
                >
                  <p class="font-16">{{item.changeDeviceCode}}</p>
                  <p>{{$t('integration.type')}}:
                    {{ item.changeDeviceType ? $t(equiIconConvert(item.changeDeviceCatalog, item.changeDeviceType).title) : ''}}
                  </p>
                  <i class="el-icon-circle-close color-red" style="position: absolute;top:5px;right:10px;"
                    @click="delteDevice(item, index)"></i>
                </div>
              </div>
            </div>
           </el-form-item> -->

       </el-form>
        <el-button type="primary" style="margin-left: 160px !important;"
          @click="saveDeviceCarrier" >{{ $t('integration.submit') }}
        </el-button>
    </div>

    <!-- 设备列表 -->
    <DeviceList
      v-if="isShowDeviceList"
      :isShow="isShowDeviceList"
      :selDeviceList="dioForm.deviceList"
      :sceneId="dioForm.sceneId"
      :structureId="dioForm.structureId"
      @updateDevice="updateDevice"
      @close="isShowDeviceList = false">
    </DeviceList>
  </div>
</template>
<script>
import { getLanguage } from '@/lang';
import { getCarrierType, shareParam, shareTree } from '@/api/modules/public'
import { getRegisterCarrierList, saveRegisterCarrier, getRegisterCarrierDetail, getRegisterDeviceList } from '@/api/modules/device'
import DeviceList from "./DeviceList.vue"
import { equiIconConvert, unitCodeConvert, unitIdConvert, deviceTypeConvert } from '@/utils/convert';
import {
  shareUnit,shareRange, carrierDetail, carrierRelectList, displayDelete
} from '@/api/modules/carrier.js'
export default {
  components: {
    DeviceList
  },
  data(){
    return {
      equiIconConvert,
      deviceTypeConvert,
      getLanguage,
      carrierList: [],
      carrierName: '',
      dioForm: {
        carrierName: '',
        structureName: '',
        structureId: '',
        sceneId: '',
        nodeId: '',
        parentCode: '',
        carrierId: '',
        carrierModel: 1, // 默认是普通模式
        carrierType:'',
        rangeList: [],
        deviceList: [],
         // 所选的组织架构名称，用于显示
        structureText: ''
      },
      carrierTypeOptions: [],
      modeList:[],
      isShowDeviceList: false,
      isShowUnitInput: false,

      treeData: [],

      // 检测区间
      ranges: [],
      // 用于渲染的units
      renderUnits: [],
      // range缓存 不用每次都重新请求  根据unitId来区分
      rangeCache: {},
      // 区间Map 用rangeId来区分
      rangeMap: {},
      units: [],

      deviceList: {},
      selDeviceList:[],

      mode: 'add', // 新增还是编辑

    }
  },
  computed: {
    dataTree() {
      return this.$store.getters.SchemaTree.filter(item => {
          return item.sceneCode !== 'all_node';
      });
    },
    rules() {
      return {
          structureText: [
              {
                  required: true,
                  message: this.$t('messageTitle.ContentNotEmpty'),
                  trigger: 'change'
              }
          ],
          carrierName: [
              {
                  required: true,
                  message: this.$t('messageTitle.ContentNotEmpty'),
                  trigger: 'blur'
              }
          ],
          carrierType: [{ required: true, message: $t('integration.mount_status_cannot_be_empty'), trigger: 'change' }],
          carrierModel: [
              {
                  message: $t('integration.monitoring_point_mode_must_be_selected'),
                  trigger: 'blur',
                  required: true
              }
          ]
      };
    },
    isPulsBool () {
      return !(this.ranges && this.ranges.length)
    },
  },
   mounted(){
    this.getTree()
    this.getCarrierList()
    this.getCarrierType()
    this.getModeList()
    this.getUnits()
    this.getDeviceList()
  },
  methods: {
    // 获取组织架构
    getTree () {
      shareTree({
        isEdit: 0,
        all: true
      }).then(({ result }) => {
        this.treeData = (result && result.item) || []
        this.treeData = this.treeData.filter(item => {
          return item.sceneCode !== 'all_node';
        });
      })
    },
    // 获取监测点类型下拉框
    getCarrierType () {
      getCarrierType().then(({ result }) => {
       this.carrierTypeOptions = result.map(item => {
            return {
                value: item.id,
                label: getLanguage() === 'zh_CN'? item.name: item.code
            };
        });
        // 默认监测点类型第一项
        if(this.carrierTypeOptions.length){
          this.dioForm.carrierType = this.carrierTypeOptions[0].value
        }
      })
    },
    getModeList(){
      shareParam({
          type:0,
          code:'carrier_mode'
      }).then(({result})=>{
          this.modeList = result;
      })
    },
    searchCarrier(){
      console.log('----searchCarrier-----------')
      let name =  this.carrierName
      getRegisterCarrierList({carrierName: name}).then(res => {
        this.carrierList = res.result ? res.result : []
      })
    },

    getDeviceList(){
      getRegisterDeviceList().then(res => {
        console.log('res')
        this.deviceList = res.result ? res.result : {}
        console.log(' this.deviceList---',  this.deviceList)
      })
    },
    showDeviceDiaFn(){
      if(this.dioForm.sceneId || this.dioForm.structureId){
        this.isShowDeviceList = true
      }else{
        this.$message.error($t('integration.please_select_unit_path'))
         return
      }
    },
    // 选择设备
    updateDevice(device){
      this.dioForm.deviceList.push({
        changeDeviceId: device.id,
        changeDeviceCatalog: device.deviceCatalog,
        changeDeviceCode: device.deviceCode,
        changeDeviceType: device.deviceType
      })
      console.log('this.dioForm.deviceList=', this.dioForm.deviceList)
    },
    handleSelectDevice(device){
      // 不能选
      if(device.carrierDeviceId && device.carrierDeviceStatus ===1){
        return
      }

      if(device.select){
        this.$set(device, 'select', false)
        let index = this.dioForm.deviceList.findIndex(_ => _.changeDeviceId === device.deviceId)
        if(index !== -1){
          this.dioForm.deviceList.splice(index, 1)
        }

      }else{
        if(device.carrierDeviceId && device.carrierDeviceStatus !==1){
          this.$message.warning($t('integration.device_select_tips'))
        }
        this.dioForm.deviceList.push({
          changeDeviceId: device.deviceId,
          changeDeviceCatalog: device.deviceCatalog,
          changeDeviceCode: device.deviceCode,
          changeDeviceType: device.deviceType
        })
        this.$set(device, 'select', true)
        this.selDeviceList = [...this.dioForm.deviceList]
      }

    },
    // 删除所选设备
    delteDevice(device,index){
      // let index = this.dioForm.deviceList
      this.dioForm.deviceList.splice(index, 1)

      // if(this.mode === 'add'){
      //   this.dioForm.deviceList.splice(index, 1)
      // }else{
      //   // 设备身上的取消关联设备
      //   this.$confirm($t('integration.are_you_sure_you_want_to_dissociate_this_device')).then(res => {

      //   })
      // }
    },

    //获取设备注册监测点列表
    getCarrierList(){
      console.log('----getCarrierList-----------')
      getRegisterCarrierList().then(res => {
        this.carrierList = res.result ? res.result : []
      })
    },
    nodeClick({ label }) {
      console.log('label===', label)
      // if (label.level === 0) return this.$message.warning(this.$t('messageTitle.SelectTheNodeUnderTheRange'));
      this.dioForm.sceneId = label.scopeId;
      this.dioForm.nodeId = label.sceneId ? label.sceneId : label.scopeId;
      // this.dioForm.parentCode = label.parentCode ? label.parentCode : label.sceneCode;
      this.dioForm.parentCode = label.level !== 1 ? label.parentCode : label.sceneCode;
      this.dioForm.structureId =  label.sceneId
      this.dataTree.forEach(item => {
          if (item['scopeId'] === label.scopeId) {
              // this.dioForm.structureText = item.label + '-' + label.label;
              // this.dioForm.structureName = label.label;
              this.dioForm.structureText = label.label;
          }
      });
    },
    // 点击列表中某个监测点编辑
    changeCarrier(item){
      console.log('item===', item)
      this.mode = 'edit'

     this.resetSelect()

      getRegisterCarrierDetail(item.id).then(({result, state}) => {
        this.dioForm = {
            carrierName: result.carrierName,
            structureName: '',
            sceneId: result.sceneId,
            nodeId: '',
            parentCode: '',
            carrierModel: result.carrierModel,
            carrierType:result.carrierType,
            rangeList: result.rangeList,
            deviceList: [],
            structureText: result.structureName,
            carrierId: result.carrierId,
            structureId: result.structureId
          }
        result.carrierDeviceList.forEach(device => {
           if(device.deviceCode){
            this.dioForm.deviceList.push({
              changeDeviceId: device.deviceId,
              changeDeviceCatalog: device.deviceCatalog,
              changeDeviceCode: device.deviceCode,
              changeDeviceType: device.deviceType,
              id: device.id
            })
           }else{
              this.dioForm.deviceList.push({
                changeDeviceId: device.changeDeviceId,
                changeDeviceCatalog: device.changeDeviceCatalog,
                changeDeviceCode:  device.changeDeviceCode,
                changeDeviceType: device.changeDeviceType,
                id: device.id
              })
           }
        })

        for(let key in this.deviceList){
          if(this.deviceList[key] && this.deviceList[key].length){
            this.deviceList[key].forEach(dev => {
              if(this.dioForm.deviceList.findIndex(_ => _.changeDeviceId == dev.deviceId) !== -1){
                this.$set(dev, 'select', true)
              }
            })
          }
        }

        // this.deviceList = [...this.dioForm.deviceLis]
        this.ranges = [...this.dioForm.rangeList]
        console.log('ranges----', this.ranges)
        this.ranges.forEach(item => {
          // 手动增加unitId
          this.$set(item, 'unitId', unitIdConvert(item.unitCode))
          this.$set(item, 'unit', item.unitName)
           shareRange({
                scope: this.dioForm.sceneId,
                unit: unitIdConvert(item.unitCode)
              })
                .then(({ result }) => {
                  this.$set(item, 'forwardNameArray', result)
                  result.forEach(range => {
                    this.$set(this.rangeMap, range.id, range)
                  })
                })
         })
        console.log('ranges----', this.ranges)

      })
      // this.dioForm = {
      //   carrierName: item.keycode,
      //   structureName: item.structureName,
      //   sceneId: item.sceneId,
      //   nodeId: item.nodeId,
      //   parentCode: item.parentCode,
      //   carrierModel: item.mode,
      //   carrierType:item.typeId,
      //   rangeList: item.rangeList,
      //   deviceList: item.deviceList,
      // }
      // 因为列表的数据不全，需要调获取监测点详情接口和监测点下面设备列表的接口
      // carrierDetail(item.typeId, item.id).then(({result, state}) => {
      //   if(state.code === 200){
      //     this.dioForm = {
      //       carrierName: result.keycode,
      //       structureName: '',
      //       sceneId: result.sceneId,
      //       nodeId: '',
      //       parentCode: '',
      //       carrierModel: result.mode,
      //       carrierType:result.typeId,
      //       rangeList: [],
      //       deviceList: [],
      //       structureText: result.structureName,
      //       carrierId: result.id,
      //       structureId: result.structureId
      //     }
      //   }

      //   carrierRelectList(item.typeId, item.id).then(({ result }) => {
      //    result.forEach(device => {
      //      if(device.deviceCode){
      //       this.dioForm.deviceList.push({
      //         changeDeviceId: device.deviceId,
      //         changeDeviceCatalog: device.deviceCatalog,
      //         changeDeviceCode: device.deviceCode,
      //         changeDeviceType: device.deviceType,
      //         id: device.id
      //       })
      //      }else{
      //         this.dioForm.deviceList.push({
      //           changeDeviceId: device.changeDeviceId,
      //           changeDeviceCatalog: device.changeDeviceCatalog,
      //           changeDeviceCode:  device.changeDeviceCode,
      //           changeDeviceType: device.changeDeviceType,
      //           id: device.id
      //         })
      //      }
      //     // 整理监测区间
      //     if(device.range){
      //       console.log('device.range=', device.range)
      //       this.dioForm.rangeList = this.dioForm.rangeList.concat(device.range)
      //       this.ranges = [...this.dioForm.rangeList]
      //     }

      //    })

      //    this.ranges.forEach(item => {
      //      shareRange({
      //           scope: this.dioForm.sceneId,
      //           unit: item.unitId
      //         })
      //           .then(({ result }) => {
      //             this.$set(item, 'forwardNameArray', result)
      //             result.forEach(range => {
      //               this.$set(this.rangeMap, range.id, range)
      //             })
      //           })
      //    })

      //    this.$forceUpdate()

      //    console.log('this.dioForm==', this.dioForm)
      //    console.log('this.dioForm==', this.ranges)

      //  })

      // })


    },


    // 删除监测点
    delCarrierFn(item){
      this.$confirm(this.$t('messageTitle.DeleteToContinue'), this.$t('public.prompt'), {
        confirmButtonText: this.$t('public.btn_yes'), // 确定按钮的文案
        cancelButtonText: this.$t('public.btn_cancel'), // 取消按钮的文案
        type: 'warning'
      })
        .then(() => {
          displayDelete({id: item.id}, item.typeId).then(async ({ state }) => {
            await this.$resultHandle(state)
            this.getCarrierList()
          })
        })

    },
    resetSelect(){
      for(let key in this.deviceList){
        if(this.deviceList[key] && this.deviceList[key].length){
          this.deviceList[key].forEach(dev => {
            this.$set(dev, 'select', false)
          })
        }
      }
    },
    addDeviceCarrier(){
      this.mode = 'add'
      this.resetForm()
      this.resetSelect()
    },
    resetForm(){
      this.dioForm = {
        carrierName: '',
        structureName: '',
        structureId: '',
        sceneId: '',
        nodeId: '',
        parentCode: '',
        carrierId: '',
        carrierModel: 1,
        carrierType:'',
        rangeList: [],
        deviceList: [],
        structureText: ''
      }
      this.ranges = []
      this.isShowUnitInput = false
      this.renderUnits.forEach(item => {
        this.$set(item, 'disabled', false)
      })
      this.mode = 'add'
    },
    // 保存设备监测点
    saveDeviceCarrier(){
      console.log('this.dioForm===', this.dioForm)
      console.log('ranges-----', this.ranges)
      this.dioForm.rangeList = []
      this.ranges.forEach(rang => {
        // 自定义区间和已有的区间提交时参数不一样
        if(rang.unitId === 'custom'){
          this.dioForm.rangeList.push({
            unitCode: unitCodeConvert(rang.unit),
            name: rang.min + '-' + rang.max +  rang.unit,
            max: rang.max,
            min: rang.min
          })
        }else{
          this.dioForm.rangeList.push({
            unitCode: unitCodeConvert(rang.unitId),
            name: rang.name,
            max: rang.max,
            min: rang.min,
            id: rang.id
          })
        }

      })



      this.$refs['form'].validate((valid) => {
        if(valid){
          let params = {
            carrierName: this.dioForm.carrierName,
            sceneId: this.dioForm.sceneId,
            carrierModel: this.dioForm.carrierModel,
            carrierType:this.dioForm.carrierType,
            rangeList: this.dioForm.rangeList,
            // deviceList: this.dioForm.deviceList,
            deviceList: [],
          }
          // 是选择现有的架构和新增架构，参数不一样

          if(this.dioForm.structureName){ //新增架构
            params.structureName = this.dioForm.structureName
            params.nodeId = this.dioForm.nodeId
            params.parentCode = this.dioForm.parentCode
          }else{
            params.structureId = this.dioForm.structureId

          }

          if(this.mode === 'edit'){
            params.carrierId = this.dioForm.carrierId
          }

          // 保存时没有‘暂无设备’的去掉
         this.dioForm.deviceList.forEach(dev => {
           if(dev.changeDeviceType !==0 && dev.changeDeviceId !==0){
            params.deviceList.push(dev)
           }
         })
          console.log('params==', params)

          saveRegisterCarrier(params).then(res => {
            if (res.state.code === 200 && res.result === 2000) {
              this.$message.success($t('integration.success'));
              this.getCarrierList()
              this.resetForm()
              this.resetSelect()

            }else{
              this.$message.error($t('integration.fail'))
              if(res.result === -3){
                this.$message.warning($t('integration.cannot_add_child_nodes'))
                return
              }else if(res.result === -2){
                this.$message.warning($t('integration.same_node_exists'))
                return
              }else if(res.result === -1){
                this.$message.warning($t('guideText.Maximum_value27'))
                return
              }else if (result === 411) {
                this.$message.error($t('integration.the_same_mount_name_exists'));
              } else if (result === 412) {
                this.$message.error($t('integration.the_range_of_the_user_is_inconsistent_with_the_current_page_range'));
              } else if (result === 412) {
                this.$message.error($t('integration.the_range_of_the_user_is_inconsistent_with_the_current_page_range'));
              } else {
                this.$message.error(state.msg);
              }
            }
          })
        }
      })
    },
    // 获取监测区间单位
    async getUnits () {
      if (!this.renderUnits.length) {
        const units = await shareUnit()
        this.units = [...units.result]
        this.renderUnits = units.result
        this.renderUnits.push({
          id: 'custom',
          title: this.$t('home.custom'),
        })
      }
    },
    handleClick () {
      this.ranges.push({
        unitId: '',
        id: '',
        unit: '',
        min: '',
        max: '',
        disabled: false,
        forwardNameArray: []
      })
    },
    // 改变检测区间
    changeFn (id, index) {
      this.ranges[index].min = ''
      this.ranges[index].max = ''
      this.ranges[index].id = ''


      // 如果选的是自定义
      if(id === 'custom'){
        this.units.forEach(item => {
          this.ranges[index].forwardNameArray.push({
            ...item,
            unit: item.name,
            name: item.title + '(' + item.name + ')'
          })
        })
      }else{
        this.renderUnits.forEach(item => {
        if (id === item.id) {
          this.ranges[index].unit = item.name
          this.$set(item, 'disabled', true)
        }
        if(this.ranges.findIndex(_ => _.unitId === item.id) === -1){
            this.$set(item, 'disabled', false)
          }
        })
        this.shareUnitFn(id, index)
      }

      console.log('this.ranges-=-', this.ranges)

    },
    shareUnitFn (id, index) {
      shareRange({
        scope:  this.dioForm.sceneId ,
        unit: id
      }).then(({ result }) => {
        this.ranges[index].forwardNameArray = result
        result.forEach(range => {
          this.$set(this.rangeMap, range.id, range)
        })
      })
    },
    changeNameFn (id, index) {
      this.ranges[index].min = ''
      this.ranges[index].max = ''

      console.log('id, index=', id, index)
      // 如果选的是自定义
      if(this.ranges[index].unitId === 'custom'){
        this.ranges[index].forwardNameArray.forEach(item => {
          if (id === item.id) {
            this.ranges[index].unit = item.unit
            // this.ranges[index].max = item.max
            // this.ranges[index].name = item.name
          }
        })
      }else{
        this.ranges[index].forwardNameArray.forEach(item => {
          if (id === item.id) {
            this.ranges[index].min = item.min
            this.ranges[index].max = item.max
            this.ranges[index].name = item.name
          }
        })
      }


    },
    addRow () {
      this.ranges.push({
        unitId: '',
        id: '',
        unit: '',
        min: '',
        max: '',

        forwardNameArray: []
      })
    },
    delRow (index, option) {
      this.renderUnits.forEach(item => {
        if (option.unitId === item.id) {
          this.$set(item, 'disabled', false)
        }
      })
      this.ranges.splice(index, 1)
      // if (this.ranges.length === 0) {

      //     this.isPulsBool = true;
      // }
    },
  }
}
</script>
<style lang="scss" scoped>
.probeClass {
  margin-bottom: 10px;

  span {
    margin-right: 5px;
  }

  i {
    margin-left: 10px;
  }
}

.treeClass {
  height: 100%;
  overflow: auto;

  .el-tree {
    height: 100%;
  }
}

</style>
